// src/components/WalletSecurity/WalletAuthButton.jsx
// Botón de auth por wallet, autocontenido y reutilizable (páginas /login y /register).
// Usa el hook SIWE compartido (useWalletLogin). El mismo botón sirve para entrar y para
// crear: si no hay sesión Privy, abre su modal (crea wallet embebida para usuarios nuevos),
// firma y verifica contra el backend. Solo montar con REACT_APP_PRIVY_APP_ID (lo decide el caller).
import React from 'react';
import { FiArrowRight } from 'react-icons/fi';
import { FaWallet } from 'react-icons/fa';
import { useWalletLogin } from '../../lib/useWalletLogin';
import './WalletAuthButton.css';

export default function WalletAuthButton({ label = 'Entrar con tu wallet', onSuccess }) {
  const { start, status, error, ready, busy } = useWalletLogin(onSuccess);

  const text = status === 'signing'    ? 'Firmá en tu wallet…'
             : status === 'verifying'  ? 'Verificando…'
             : status === 'connecting' ? 'Conectando…'
             : label;

  return (
    <div className="wab">
      <button type="button" className="wab-btn" onClick={start} disabled={!ready || busy}>
        <FaWallet className="wab-ic" />
        {busy ? <span className="wab-spin" /> : <>{text} <FiArrowRight /></>}
      </button>
      {error && <div className="wab-error">{error}</div>}
      <p className="wab-note">
        <strong>Tu plata, tu llave.</strong> Sin contraseña: entrás con tu wallet.
        Firmar solo prueba que sos vos — no mueve tus fondos.
      </p>
    </div>
  );
}
